var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container admin"
  }, [_c('div', {
    staticClass: "menu menu-admin",
    attrs: {
      "role": "menu"
    }
  }, [_vm._v("\n    bioplan architekten"), (_vm.isLoggedIn && _vm.userData) ? [_vm._v(" - " + _vm._s(_vm.userData.username) + " - "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])] : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.isLoggedIn) ? _c('ul', [_c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminUsers'
    },
    attrs: {
      "to": {
        name: 'AdminUsers'
      }
    }
  }, [_vm._v("Benutzer")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminSlides'
    },
    attrs: {
      "to": {
        name: 'AdminSlides'
      }
    }
  }, [_vm._v("Slides")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminPersons'
    },
    attrs: {
      "to": {
        name: 'AdminPersons'
      }
    }
  }, [_vm._v("Personen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminCategories'
    },
    attrs: {
      "to": {
        name: 'AdminCategories'
      }
    }
  }, [_vm._v("Kategorien")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminEntries'
    },
    attrs: {
      "to": {
        name: 'AdminEntries'
      }
    }
  }, [_vm._v("Einträge")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminPages'
    },
    attrs: {
      "to": {
        name: 'AdminPages'
      }
    }
  }, [_vm._v("Seiten")])], 1)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e71014b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/admin/AdminMain.vue
// module id = 210
// module chunks = 1